/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `s1` - water level
 * * `vol` - volume
 * * `su` - wet surface
 * * `infiltration_rate_simple` - infiltration rate
 * * `rain` - rain
 * * `q_lat` - lateral discharge
 * * `q_sss` - surface source sink discharge
 * * `ucx` - flow velocity x
 * * `ucy` - flow velocity y
 * * `leak` - leakage
 * * `intercepted_volume` - intercepted volume
 * * `u1` - flow velocity
 * * `q` - discharge
 * * `au` - wet cross section
 * * `up1` - flow velocity interflow layer
 * * `qp` - discharge interflow layer
 * * `breach_depth` - breach depth
 * * `breach_width` - breach width
 * * `q_pump` - pump discharge
 * @export
 */
export const CustomizedHydroOutputVariablesEnum = {
  S1: "s1",
  VOL: "vol",
  SU: "su",
  INFILTRATION_RATE_SIMPLE: "infiltration_rate_simple",
  RAIN: "rain",
  Q_LAT: "q_lat",
  Q_SSS: "q_sss",
  UCX: "ucx",
  UCY: "ucy",
  LEAK: "leak",
  INTERCEPTED_VOLUME: "intercepted_volume",
  U1: "u1",
  Q: "q",
  AU: "au",
  UP1: "up1",
  QP: "qp",
  BREACH_DEPTH: "breach_depth",
  BREACH_WIDTH: "breach_width",
  Q_PUMP: "q_pump",
} as const;
export type CustomizedHydroOutputVariablesEnum =
  (typeof CustomizedHydroOutputVariablesEnum)[keyof typeof CustomizedHydroOutputVariablesEnum];

export function instanceOfCustomizedHydroOutputVariablesEnum(value: any): boolean {
  for (const key in CustomizedHydroOutputVariablesEnum) {
    if (Object.prototype.hasOwnProperty.call(CustomizedHydroOutputVariablesEnum, key)) {
      if (
        CustomizedHydroOutputVariablesEnum[
          key as keyof typeof CustomizedHydroOutputVariablesEnum
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomizedHydroOutputVariablesEnumFromJSON(
  json: any
): CustomizedHydroOutputVariablesEnum {
  return CustomizedHydroOutputVariablesEnumFromJSONTyped(json, false);
}

export function CustomizedHydroOutputVariablesEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CustomizedHydroOutputVariablesEnum {
  return json as CustomizedHydroOutputVariablesEnum;
}

export function CustomizedHydroOutputVariablesEnumToJSON(
  value?: CustomizedHydroOutputVariablesEnum | null
): any {
  return value as any;
}

export function CustomizedHydroOutputVariablesEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): CustomizedHydroOutputVariablesEnum {
  return value as CustomizedHydroOutputVariablesEnum;
}
